const en = {
  teacher_login: 'Teacher Login',
  login_out: 'Log Out',
  back_home: 'Home',
  back: 'back',
  activity_dynamics: 'Campus Dynamics',
  activity_events: 'Events',
  activity_students: 'Students',
  activity_public: 'Public Welfare courses',
  about_us: 'About us',
  about_agent: 'FAQ',
  about_join: 'Student Review',
  about_business: 'Business School',
  down_title: 'Course software download',
  down_usepc: 'Use A computer to teach a class',
  down_google: 'Google chrome is recommended',
  down_system: 'Windows 7 and ABOVE/MAC OS',
  down_button: 'Download now',
  release_time: 'time',
  teacher_username: 'username',
  teacher_password: 'password',
  teacher_sign: 'Sign In',
  time_setting: 'Timetable Setting',
  teacher_course: 'My Course',
  teacher_group: 'Groups',
  teacher_assignment: 'Assignment list',
  teacher_profile: 'Profile',
  teacher_rules: 'Rules and Notices',
  profile: 'Profile',
  hours_amount: 'Service fee',
  view_comment: 'Comment',
  change_password: 'Change Password',
  teacher_report: 'Report',
  teacher_schedule: 'My Schedule',
  teacher_enter_class: 'Teachers can enter the classroom to prepare for class',
  teacher_none: 'None',
  none: 'None',
  course_stand: 'Upcoming Classes',
  course_finished: 'Finished',
  course_finished_month: 'Finished Classes',
  group: 'Group',
  student_number: 'Number of student',
  people: 'People',
  pregress_note: 'Pregress note',
  message: 'Message',
  material: 'Lesson material',
  material2: 'Material Notes',
  feedback: 'Feedback',
  enter_classroom: 'enter classroom',
  record: 'Recording',
  click_record: 'Click record',
  edit_attandeny: 'Edit attandeny',
  checking_attandeny: 'Checking attandeny',
  edit: 'Edit',
  students: 'Students',
  old_password: 'Change Password',
  new_password: 'New password',
  confirm_password: 'Confirm Password',
  cancel: 'Cancel',
  username: 'User name',
  teacher_name: 'Teacher name',
  contact: 'Contact',
  gender: 'Gender',
  female: 'Female',
  male: 'Male',
  save: 'Save',
  today: 'Today',
  month: 'Month',
  week: 'Week',
  day: 'Day',
  list: 'List',
  setup_homework: 'Setup homework',
  date: 'Date',
  detail: 'Detail',
  delete: 'Delete',
  search: 'Search',
  keyword: 'Keyword',
  start: 'Start',
  end: 'End',
  topic: 'Topic',
  content: 'Content',
  upload_picture_message: 'Only accept jpg/png file, cant be more than 2MB as well as 9 pictures',
  upload_video_message: 'Only accept MP4 file, cant be more than 50MB as well as 4 videos',
  upload_video_no: 'Your browser does not support video playback',
  video: 'Video',
  upload: 'Upload',
  edit_homework: 'Edit homework',
  homework_detail: 'homework Detail',
  homework_comment: 'Teacher reviews',
  homework_comment_score: 'Scoring',
  homework_comment_content: 'Commentary',
  homework_comment_btn: 'Save',
  group_list: 'Group list',
  lesson_number: 'Number of lesson',
  lesson: 'Lesson',
  school_code: 'Code',
  call_detail: 'Call record',
  attandency: 'Attandency',
  present: 'Present',
  amount: 'Amount',
  group_history: 'Group history',
  submit: 'Submit',
  all: 'All',
  number: '',
  go: 'Go',
  page: 'Page',
  class_remarks: 'Class Remarks',
  files: 'Files',
  cancel_class: 'Cancel',
  cancel_class_title: 'Cancellation of classes',
  cancel_class_note: 'Cancel Remarks',
  cancel_class_picture: 'Upload attestation',
  cancel_class_type: 'Cancel reason',
  class_sign_in: 'Class sign in',
  signed_in: 'Signed in',
  cs_help: 'CS Help',
  note: 'Note',
  help_class_type: 'Category',
  teacher_home: 'Home',
  Review_Display: 'Review Display',
  Problem_Feedback: 'Problem Feedback',
  TM_Feedback: 'TM Feedback'
}
export default en



// WEBPACK FOOTER //
// ./src/lang/en.js